export const ECOSYSTEM_APPS_GROUP_INDEX = 3;
